import { Observable } from 'rxjs';

export interface HubMst {
  id?: any;
  hubId?: any;
  divisionId: any;
  divisionName?: string;
  districtId: any;
  districtName?: string;
  stateId: any;
  stateName?: string;
  hubName: string;
  registrationNo?: string;
  contactNumber?: string;
  email?: string;
  addressLine1?: string;
  addressLine2?: string;
  city?: string;
  cityAreaId?: any;
  pincode?: string;
  printHeaderText?: string;
  displayName?: string;
  restrictFlag: boolean;
  isActive: boolean;
  createdBy?: number;
}

export abstract class HubMstData {
  abstract list(url: string): Observable<any>;
  abstract getById(url: string): Observable<HubMst>;
  abstract create(url: string, data: HubMst): Observable<any>;
  abstract update(url: string, data: HubMst): Observable<any>;
}
